import de from "./de";
import en from "./en";
import es from "./es";
import fr from "./fr";
import ko from "./ko";
import pt from "./pt";
import zh from "./zh";
import fa from "./fa";

export default { de, en, es, fr, ko, pt, zh, fa };
